import React, { useState } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import MessageList from './MessageList';
import MessageForm from './MessageForm';
import './MotivationSystem.scss';

const MotivationSystem = () => {
    const [activeView, setActiveView] = useState('list');
    const [editingMessage, setEditingMessage] = useState(null);
    const { t } = useLanguage();

    const handleAddMessage = () => {
        setEditingMessage(null);
        setActiveView('form');
    };

    const handleEditMessage = (message) => {
        setEditingMessage(message);
        setActiveView('form');
    };

    const handleBackToList = () => {
        setActiveView('list');
        setEditingMessage(null);
    };

    return (
        <div className="motivation-system">
            <div className="motivation-header">
                <h1>{t('motivationModule')}</h1>
                <p>{t('motivationModuleDesc')}</p>
            </div>

            {activeView === 'list' && (
                <MessageList
                    onAddMessage={handleAddMessage}
                    onEditMessage={handleEditMessage}
                />
            )}

            {activeView === 'form' && (
                <MessageForm
                    message={editingMessage}
                    onBack={handleBackToList}
                    onSuccess={handleBackToList}
                />
            )}
        </div>
    );
};

export default MotivationSystem;